import { render, staticRenderFns } from "./set-outer.vue?vue&type=template&id=72e25df5&"
import script from "./set-outer.vue?vue&type=script&lang=js&"
export * from "./set-outer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports